<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup User
 * @created at      :   2024/07/30
 * @created by      :   Hainn – HaiNN@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import store from '@/store';
import template from './template.html';
import { mapMutations, mapActions, mapState } from 'vuex';
import PopupUserCustomer from '@/views/popupSearch/popup_user_customer/store';
/**
 * Define component for popup
 */
import helpers from '@/utils/helpers';

var User = {
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number],
        isShowFooter: Boolean
    },
    beforeCreate() {
        if (!store.hasModule('PopupUserCustomer')) {
            store.registerModule('PopupUserCustomer', PopupUserCustomer);
        }
    },
    created() {
        this.onInitScreen();
        if (this.initData) {
            this.customer_cd = this.initData;
        } else {
            this.customer_cd = '';
        }
        this.onSearchItem();
    },
    data() {
        return {
            customer_cd: ''
        };
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName', 'referDataChoose'],
    computed: {
        ...mapState('PopupUserCustomer', ['listData', 'data', 'msgNoData', 'totalRows'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        ...mapActions('PopupUserCustomer', ['searchUserCustomerInfo']),
        ...mapMutations('PopupUserCustomer', ['resetDataInit', 'setPageNavigation', 'setPageNo']),
        onSearchItem() {
            this.setPageNavigation({
                currentPage: 1,
                perPage: this.data.pageSize
            });
            this.data.customer_cd = this.customer_cd;
            this.searchUserCustomerInfo(this.data);
        },
        changeCurrentPage(data) {
            this.data.customer_cd = this.customer_cd;
            this.data.pageNo = data.currentPage;
            this.data.pageSize = data.perPage;
            this.searchUserCustomerInfo(this.data);
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        chooseUser(data) {
            this.$emit('onReferModelValue', data.user_cd);
            this.$emit('onReferValueName', data.user_name);
            this.$emit('close');
            // this.$emit('referDataChoose', data);
        }
    }
};
export default User;
</script>

<style lang="scss">
@import '@/assets/scss/common/popup.scss';
</style>
